import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ServiceHelpersService } from '../../_helpers/service-helpers.service';
import { UserDataService } from '../data-services/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class ChangeProfileEmailService {
  email: any = "";
  process = false;
  private messageSource = new BehaviorSubject<any>(this.email);
  private processSource = new BehaviorSubject<any>(this.process);
  $email = this.messageSource.asObservable();
  $process = this.processSource.asObservable();

  constructor(
    private http: HttpClient,
    private serviceHelpers: ServiceHelpersService,
    private userDataService: UserDataService
  ) {}

  changeAccountEmail(oldEmail, newEmail): Observable<any> {
    let url = '';
    const body = {
      email: newEmail,
      password: '',
    };
    this.userDataService.$userData.subscribe((userData) => {
      url = `${
        environment.backend_server_url_account
      }/change-email?email=${oldEmail}&name=${
        userData.userDetails.firstName || ''
      }`;
    });
    return this.http.put(url, body, this.serviceHelpers.options);
  }

  checkEmailExists(oldEmail, newEmail): Observable<any> {
    const url = `${environment.backend_server_url_identity}/check-email?email=${oldEmail}`;
    const body = {
      email: newEmail,
      password: '',
    };
    return this.http.put(url, body, this.serviceHelpers.options);
  }

  saveEmail(email) {
    this.messageSource.next(email);
  }

  saveProcess(b) {
    this.processSource.next(b);
  }

  clearEmail() {
    this.messageSource.next('');
  }

  clearProcess() {
    this.processSource.next(false);
  }
}
